module.exports = __webpack_public_path__ + "static/media/r5s1.635dd554.jpg";